import {AuthService} from "./Auth";
import {User} from "oidc-client";
import { StateService } from "@uirouter/angularjs";

export class AuthHelper  {
    static $inject = ['AuthService', '$interval', 'jwtHelper', '$state'];
    constructor(public authService: AuthService, public interval: ng.IIntervalService, public jwtHelper: any, public $state: StateService) {
    }

    startMonitoring() {
        this.interval(this.checkAuth.bind(this), 10000);
    }

    checkAuth(){
        this.authService.getUser().then((user:User):void=>{

            if (user) {
                console.log("****** token checkAuth..");
                var expiresInSeconds = user.expires_in;
                console.log("****** expiring in.. "+expiresInSeconds);
                var tokenExpiring = expiresInSeconds < 60;
              //var expireDate:Date = this.jwtHelper.getTokenExpirationDate(user.access_token);
              //var offsetSeconds = 120;
              //var tokenExpiring = false;
              //var expiringTimeMs = (new Date().valueOf() + (offsetSeconds * 1000));
              //var tokenExpireTimeMs = expireDate.valueOf();
              //var sUntilExpires = (tokenExpireTimeMs - expiringTimeMs) / 1000;
              //console.log("expiring time in s="+sUntilExpires);
              //if (expireDate !== null)
              //    tokenExpiring = !(expireDate.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
              if(tokenExpiring){
                  console.log("****** token expiring soon. try refresh..");
                  this.authService.renewToken()
                      .then((user:User):any=>{
                          console.log("*********renewToken returned...");
                          if(user != null){
                              console.log("*********renewToken returned... user not null");
                              var access_token = user.access_token;
                          }
                          else{
                              console.log("*********renewToken returned... user IS null");
                              confirm('authhelper: need to login..');
                              this.authService.login();
                          }
                      })
                      .catch((exc:any):any=>{
                          console.log("*********renewToken returned... EXCEPTION");
                          this.$state.go('loggedout');
                      });
              }
              else{
                  //console.log("*******token not expiring soon.");
              }
          }
        });
    }

}
